// 20.2.2.28 Math.sign(x)
var $export = require('./$.export');

$export($export.S, 'Math', {sign: require('./$.math-sign')});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.math.sign.js
// module id = 114
// module chunks = 0